import { memo } from 'react'
import { ErrorMessage, Label, Textarea } from '../../atoms'

interface TextareaFieldProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string
  label: string
  error?: string
  skeleton?: boolean
}

export const TextareaField = memo(({ id, label, error, skeleton, ...rest }: TextareaFieldProps) =>
  skeleton ? (
    <div className="form-group">
      <span className="form-label">{label}</span>
      <Textarea skeleton />
    </div>
  ) : (
    <div className="form-group">
      <Label htmlFor={id}>{label}</Label>
      <Textarea id={id} error={!!error} {...rest} />
      <ErrorMessage message={error} />
    </div>
  ),
)

TextareaField.displayName = 'TextareaField'
